module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraBold.6b78c7ec.ttf";